
        var result = require("!!../../../../node_modules/css-loader/index.js!./loading.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/loading/loading.component.css
// module id = 603
// module chunks = 0